import { CompareAddedIcon, ComparePlusIcon, LikeFilledIcon, LikeOutlineIcon } from '@beef/ui-kit';
import { cookiesDeviceService } from "../../../utils/cookie";
import { DEVICE_TYPE } from "../constant";
export var mapDevicesPayload = function mapDevicesPayload(_ref) {
  var _favorite$action, _favorite$action2, _compare$action, _compare$action2;
  var favorite = _ref.favorite,
    compare = _ref.compare;
  var favoriteIds = cookiesDeviceService.getCookie(DEVICE_TYPE.favorite);
  var compareIds = cookiesDeviceService.getCookie(DEVICE_TYPE.compare);
  return {
    content: {
      favorite: favorite,
      compare: compare
    },
    device: {
      favorite: favorite ? {
        ids: favoriteIds,
        count: favoriteIds.length,
        data: [],
        link: {
          MainIcon: LikeOutlineIcon,
          ActiveIcon: LikeFilledIcon,
          label: favorite.label || '',
          href: favorite.href
        },
        action: favorite !== null && favorite !== void 0 && favorite.action && compare !== null && compare !== void 0 && compare.label ? {
          addText: (_favorite$action = favorite.action) === null || _favorite$action === void 0 ? void 0 : _favorite$action.addItemText,
          addedText: (_favorite$action2 = favorite.action) === null || _favorite$action2 === void 0 ? void 0 : _favorite$action2.addedItemText,
          AddIcon: ComparePlusIcon,
          AddedIcon: CompareAddedIcon,
          type: 'COMPARISON_DEVICES'
        } : null,
        button: {
          text: favorite.buttonText,
          href: favorite.href
        }
      } : null,
      compare: compare ? {
        ids: compareIds,
        count: compareIds.length,
        data: [],
        link: {
          MainIcon: ComparePlusIcon,
          ActiveIcon: CompareAddedIcon,
          label: compare.label || '',
          href: compare.href
        },
        action: favorite !== null && favorite !== void 0 && favorite.label && compare !== null && compare !== void 0 && compare.action ? {
          addText: (_compare$action = compare.action) === null || _compare$action === void 0 ? void 0 : _compare$action.addItemText,
          addedText: (_compare$action2 = compare.action) === null || _compare$action2 === void 0 ? void 0 : _compare$action2.addedItemText,
          AddIcon: LikeOutlineIcon,
          AddedIcon: LikeFilledIcon,
          type: 'FAVORITE_DEVICES'
        } : null,
        button: {
          text: compare.buttonText,
          href: compare.href
        }
      } : null
    }
  };
};